import React from "react";
import { Link } from "react-router-dom";
import alertify from "alertifyjs";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import axios from "axios";
import $ from "jquery";
import APIModel from "../../Models/APIModel";
import Box from "@material-ui/core/Box";
import { Input, InputAdornment, IconButton } from "@material-ui/core";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import { formLabelClasses } from "@mui/material";
import {
  displayAlertifyError,
  displayAlertifySuccess,
} from "../../util/functions";

class Login extends React.Component {
  constructor() {
    super();
    this.state = {
      name: "",
      email: "",
      phone: "",
      password: "",
      password_confirmation: "",
      industry: "",
      host: APIModel.HOST,
      showPassword: false,
      showConfirmPassword: false,
      agreeTerms: false,
    };

    this.onChange = this.onChange.bind(this);
    this.Signup = this.Signup.bind(this);
    this.logout = this.logout.bind(this);
  }

  componentWillMount() {
    // this.setState({name:localStorage.getItem('name')});
    // this.setState({token:localStorage.getItem('Token')});
  }

  componentDidMount() {
    alertify.set("notifier", "position", "top-right");
  }

  handleClickShowPassword = () => {
    this.setState((prev) => ({
      ...prev,
      showPassword: !prev.showPassword,
    }));
  };

  handleClickShowConfirmPassword = () => {
    this.setState((prev) => ({
      ...prev,
      showConfirmPassword: !prev.showConfirmPassword,
    }));
  };

  Signup = () => {
    const phoneDigits = (this.state.phone || "").replace(/\D/g, "");
    let params = {
      name: this.state.name,
      email: this.state.email,
      phone: phoneDigits ? `+1${phoneDigits}` : "",
      password: this.state.password,
      password_confirmation: this.state.password,
      industry: this.state.industry,
    };

    if (this.state.name == "" || this.state.name === undefined) {
      displayAlertifyError({ error: "Please Enter First Name" });
      return false;
    }

    if (this.state.email == "" || this.state.email === undefined) {
      displayAlertifyError({ error: "Email is Required" });

      return;
    } else if (this.state.email.length > 0) {
      let re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (re.test(this.state.email)) {
      } else {
        displayAlertifyError({ error: "Must be a valid Email Address" });

        return;
      }
    }

    if (this.state.phone === "" || this.state.phone === undefined) {
      displayAlertifyError({ error: "Please Enter Phone Number" });
      return false;
    }

    if (phoneDigits.length !== 10) {
      displayAlertifyError({ error: "Please Enter a valid 10-digit US Phone Number" });
      return false;
    }

    if (this.state.password === "" || this.state.password === undefined) {
      displayAlertifyError({ error: "Please Enter Password" });
      return false;
    }

    if (
      this.state.password_confirmation === "" ||
      this.state.password_confirmation === undefined
    ) {
      displayAlertifyError({ error: "Please Enter Confirm Password" });
      return false;
    }

    if (this.state.password != this.state.password_confirmation) {
      displayAlertifyError({ error: "Password mismatch" });
      return false;
    }

    if (this.state.industry === "" || this.state.industry === undefined) {
      displayAlertifyError({ error: "Please Select Industry" });
      return false;
    }
    return axios
      .post(this.state.host + "signup", params, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + this.state.token,
        },
      })
      .then((response) => {
        if (response.data.status === false) {
          displayAlertifyError({ error: response.data.message });
        } else {
          displayAlertifySuccess({ message: response.data.message });
          if (response.data.user !== undefined) {
            // localStorage.setItem("UserType", "Admin");
            localStorage.setItem("user_id", response.data.user.id);
            localStorage.setItem("Token", response.data.access_token);
            localStorage.setItem("user_email", response.data.user.email);
            localStorage.setItem("name", response.data.user.name);
            localStorage.setItem("status", response.data.user.status);
          }
        
          document.getElementById("signup").reset();
        //  window.location.reload(false);
          this.setState({ name: "" });
          this.setState({ lname: "" });
          this.setState({ email: "" });
          this.setState({ password: "" });
          this.setState({ password_confirmation: "" });
          this.props.history.push("/payment");
        }
      })
      .catch(this.globalErrorHandler)
      .finally();
  };

  onChange = (e) => {
    if (this.state) {
      this.setState({ [e.target.name]: e.target.value });
      let elementName = e.target.name;
      let elementVal = e.target.value;
    }
  };

  formatUSPhone = (value) => {
    const digits = value.replace(/\D/g, "").slice(0, 10);
    if (digits.length === 0) return "";
    if (digits.length < 4) return `(${digits}`;
    if (digits.length < 7) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  };

  onPhoneChange = (e) => {
    const formatted = this.formatUSPhone(e.target.value);
    this.setState({ phone: formatted });
  };

  logout = () => {
    localStorage.clear("token");
    this.props.history.push("/");
  };

  globalErrorHandler = (error) => {
    const { response } = error;
    let message;
    if (response) {
      message = response.data.message;
    } else {
      message = error.toString();
    }
  };

  render() {
    return (
      <div className="content">
        <div className="container-fluid container-login">
          <div
            className="row justify-content-center align-items-center"
            style={{ height: "100vh" }}
          >
            <div className="col-12 col-md-9 col-xl-5">
              <div className="card">
                <div className="card-header card-header-primary">
                  <h4 className="card-title text-center text-uppercase font-weight-bold">
                    <b>Signup</b>
                  </h4>
                </div>
                <div className="card-body">
                  <div className="logo mb-1 text-center">
                    <img
                      src={process.env.PUBLIC_URL + "/logo.png"}
                      alt="Logo"
                      className="logo"
                    />
                  </div>
                  <form id="signup">
                    <div className="row">
                      <div className="col-12">
                        <div className="form-group">
                          <label className="bmd-label-floating">
                            Full Name
                          </label>
                          <input
                            type="text"
                            className="form-control input-box"
                            id="name"
                            name="name"
                            onChange={this.onChange}
                            Value={this.state.name}
                            required="required"
                            autoFocus
                          />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-12">
                        <div className="form-group">
                          <label className="bmd-label-floating">
                            Email address
                          </label>
                          <input
                            type="email"
                            className="form-control input-box"
                            id="uname"
                            name="email"
                            onChange={this.onChange}
                            Value={this.state.email}
                            required="required"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-12">
                        <FormControl
                          sx={{ m: 1 }}
                          variant="standard"
                          style={{ width: "100%" }}
                          className="form-group"
                        >
                          <label
                            className="bmd-label-floating"
                            htmlFor="phone"
                          >
                            Phone Number
                          </label>
                          <Input
                            style={{ marginTop: "-.2rem" }}
                            id="phone"
                            name="phone"
                            type="tel"
                            onChange={this.onPhoneChange}
                            value={this.state.phone}
                            inputProps={{ maxLength: 14 }}
                            startAdornment={
                              this.state.phone ? (
                                <InputAdornment position="start">
                                  +1
                                </InputAdornment>
                              ) : null
                            }
                          />
                        </FormControl>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-12">
                        <FormControl
                          sx={{ m: 1 }}
                          variant="standard"
                          style={{ width: "100%" }}
                          className="form-group"
                        >
                          <label
                            className="bmd-label-floating"
                            htmlFor="password"
                          >
                            Password
                          </label>
                          <Input
                            style={{ marginTop: "-.2rem" }}
                            id="pwd"
                            name="password"
                            onChange={this.onChange}
                            onKeyDown={this.handleKeyDown}
                            value={this.state.password}
                            type={this.state.showPassword ? "text" : "password"}
                            endAdornment={
                              <InputAdornment position="end">
                                <IconButton
                                  aria-label="toggle password visibility"
                                  onClick={this.handleClickShowPassword}
                                >
                                  {this.state.showPassword ? (
                                    <VisibilityOff />
                                  ) : (
                                    <Visibility />
                                  )}
                                </IconButton>
                              </InputAdornment>
                            }
                          />
                        </FormControl>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-12">
                        <FormControl
                          sx={{ m: 1 }}
                          variant="standard"
                          style={{ width: "100%" }}
                          className="form-group"
                        >
                          <label className="bmd-label-floating" htmlFor="pwd1">
                            Confirm Password
                          </label>
                          <Input
                            style={{ marginTop: "-.2rem" }}
                            id="pwd1"
                            name="password_confirmation"
                            onChange={this.onChange}
                            onKeyDown={this.handleKeyDown}
                            value={this.state.password_confirmation}
                            type={
                              this.state.showConfirmPassword
                                ? "text"
                                : "password"
                            }
                            endAdornment={
                              <InputAdornment position="end">
                                <IconButton
                                  aria-label="toggle password visibility"
                                  onClick={this.handleClickShowConfirmPassword}
                                >
                                  {this.state.showConfirmPassword ? (
                                    <VisibilityOff />
                                  ) : (
                                    <Visibility />
                                  )}
                                </IconButton>
                              </InputAdornment>
                            }
                          />
                        </FormControl>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12">
                        <FormControl className="col-md-12 form-group">
                          <InputLabel id="demo-simple-select-helper-label">
                            Industry
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-helper-label"
                            id="demo-simple-select-helper"
                            name="industry"
                            onChange={this.onChange}
                            label="industry"
                          >
                            <MenuItem value="">
                              <em>Choose your option</em>
                            </MenuItem>
                            <MenuItem value={"Carpentry"}>Carpentry</MenuItem>
                            <MenuItem value={"Decking"}>Decking</MenuItem>
                            <MenuItem value={"Drywall"}>Drywall</MenuItem>
                            <MenuItem value={"Electrical"}>Electrical</MenuItem>
                            <MenuItem value={"Fencing"}>Fencing</MenuItem>
                            <MenuItem value={"Flooring"}>Flooring</MenuItem>
                            <MenuItem value={"General Contracting"}>
                              General Contracting
                            </MenuItem>
                            <MenuItem value={"Handyman"}>Handyman</MenuItem>
                            <MenuItem value={"Home Builder"}>
                              Home Builder
                            </MenuItem>
                            <MenuItem value={"Nightly"}>Nightly</MenuItem>
                            <MenuItem value={"HVAC"}>HVAC</MenuItem>
                            <MenuItem value={"Insulation"}>Insulation</MenuItem>
                            <MenuItem value={"Landscaping"}>
                              Landscaping
                            </MenuItem>
                            <MenuItem value={"Masonry"}>Masonry</MenuItem>
                            <MenuItem value={"Painting"}>Painting</MenuItem>
                            <MenuItem value={"Plastering"}>Plastering</MenuItem>
                            <MenuItem value={"Plumbing"}>Plumbing</MenuItem>
                            <MenuItem value={"Roofing"}>Roofing</MenuItem>
                            <MenuItem value={"Tiling"}>Tiling</MenuItem>
                            <MenuItem value={"Windows and Decors"}>
                              Windows and Decors
                            </MenuItem>
                            <MenuItem value={"Other"}>Other</MenuItem>
                          </Select>
                        </FormControl>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-12">
                        <p style={{ textAlign: "left", margin: "12px 0 8px 0", fontSize: "12px", lineHeight: "1.5", color: "#555" }}>
                          By providing your phone number, you agree to receive SMS messages from Secure Lien Release regarding lien release updates, document requests, service notifications, and customer support. Message frequency varies. Message and data rates may apply. Reply STOP to unsubscribe at any time or HELP for assistance.
                        </p>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-12">
                        <label style={{ textAlign: "left", margin: "8px 0 0 0", fontSize: "14px", display: "flex", alignItems: "flex-start", cursor: "pointer", lineHeight: "1.4" }}>
                          <input
                            type="checkbox"
                            name="agreeTerms"
                            checked={this.state.agreeTerms}
                            onChange={(e) =>
                              this.setState({ agreeTerms: e.target.checked })
                            }
                            style={{ marginRight: "8px", marginTop: "4px" }}
                          />
                          <span>
                            <strong>Agree to Terms and Conditions</strong>
                            <br />
                            I agree to the Terms and Conditions and Privacy Policy, and I consent to receive SMS messages from Secure Lien Release.
                          </span>
                        </label>
                      </div>
                    </div>

                    <div className="mt-3">
                      <button
                        type="button"
                        className="btn btn-primary w-100"
                        onClick={() => this.Signup()}
                        disabled={!this.state.agreeTerms}
                      >
                        Sign Up
                      </button>
                    </div>
                    <div class="text-center pt-3">
                      <p class="font-weight-bold mb-0">
                        Already have an account?
                      </p>
                    </div>
                    <div>
                      <Link to="/" className="link-colour">
                        <Box fontWeight="fontWeightBold">
                          &#8592; Back To Log In
                        </Box>
                      </Link>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Login;
